import { render, staticRenderFns } from "./NewAttribute.vue?vue&type=template&id=741c36c6&scoped=true"
import script from "./NewAttribute.vue?vue&type=script&lang=js"
export * from "./NewAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741c36c6",
  null
  
)

export default component.exports